/* ---------------------------------------------------------------------------
   Klaviyo-Formular per Klick oeffnen

   Das Formular muss in Klaviyo unter Targeting & Behavior auf
   "Only show on custom trigger" stehen. Zusaetzliche Regeln dort (nur
   unbekannte Profile, Zeitverzoegerung, Pause nach dem Schliessen) gelten
   trotzdem und verhindern das Oeffnen still — das war hier die urspruengliche
   Fehlerquelle.

   Klaviyo ersetzt _klOnsite beim Laden durch ein Objekt, dessen push() die
   Befehle verarbeitet. Welche Schreibweise die im Shop geladene Version
   annimmt, laesst sich von aussen nicht feststellen, deshalb werden alle drei
   versucht. Klaviyo oeffnet das Formular trotzdem nur einmal.
--------------------------------------------------------------------------- */
function rotBarOpenKlaviyoForm(formId) {
  if (!formId) return;
  window._klOnsite = window._klOnsite || [];

  try {
    window._klOnsite.push(['openForm', formId]);
  } catch (error) {
    /* leer: naechster Weg */
  }

  if (typeof window._klOnsite.openForm === 'function') {
    try {
      window._klOnsite.openForm([formId]);
    } catch (error) {
      /* leer: naechster Weg */
    }
    try {
      window._klOnsite.openForm(formId);
    } catch (error) {
      /* leer */
    }
  }
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest?.('[data-klaviyo-form]');
  if (!trigger) return;
  event.preventDefault();
  rotBarOpenKlaviyoForm(trigger.dataset.klaviyoForm);
});

/* ---------------------------------------------------------------------------
   Mobile: Bar an den Sticky-Header koppeln

   Dawn schaltet beim Scrollen die Klassen shopify-section-header-sticky und
   shopify-section-header-hidden auf .section-header. Statt eine eigene
   Scroll-Erkennung zu bauen, wird dieser Zustand gespiegelt — so laufen Bar
   und Header garantiert synchron.
--------------------------------------------------------------------------- */
function rotBarInitSticky() {
  const bar = document.querySelector('.rot-bar[data-sticky-mobile="true"]');
  if (!bar) return;

  const section = bar.closest('.rotating-announcement-bar-section') || bar.parentElement;
  if (!section) return;
  section.classList.add('rot-bar-sticky-mobile');

  const header = document.querySelector('.section-header');

  const apply = () => {
    document.documentElement.style.setProperty('--rot-bar-height', bar.offsetHeight + 'px');
    if (!header) return;
    section.classList.toggle('rot-bar-tucked', header.classList.contains('shopify-section-header-hidden'));
  };

  apply();

  if (header && window.MutationObserver) {
    new MutationObserver(apply).observe(header, { attributes: true, attributeFilter: ['class'] });
  }
  window.addEventListener('resize', apply);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', rotBarInitSticky);
} else {
  rotBarInitSticky();
}

if (!customElements.get('rotating-announcement-bar')) {
  customElements.define(
    'rotating-announcement-bar',
    class RotatingAnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.rot-bar__viewport');
        this.items = Array.from(this.querySelectorAll('.rot-bar__item'));
        if (!this.viewport || this.items.length === 0) return;

        const active = this.items.findIndex((item) => item.classList.contains('is-active'));
        this.index = active >= 0 ? active : 0;
        this.items.forEach((item, i) => {
          item.classList.toggle('is-active', i === this.index);
          if (i === this.index) {
            item.removeAttribute('aria-hidden');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
        });

        this.interval = parseInt(this.dataset.interval, 10) || 4000;
        this.autoRotate = this.dataset.autoRotate === 'true' && this.items.length > 1;
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.timer = null;
        this.lastWidth = 0;

        this.buildDots();
        this.fitTexts();
        this.setHeight();

        if (window.ResizeObserver) {
          this.observer = new ResizeObserver(() => this.handleResize());
          this.observer.observe(this);
        }

        this.querySelector('.rot-bar__button--next')?.addEventListener('click', () => {
          this.stop();
          this.show(this.index + 1);
          this.start();
        });
        this.querySelector('.rot-bar__button--prev')?.addEventListener('click', () => {
          this.stop();
          this.show(this.index - 1);
          this.start();
        });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
        }
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', () => {
          document.hidden ? this.stop() : this.start();
        });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
      }

      /* Lange und kurze Fassung einer Meldung.
         Die lange nennt das Land, die kurze laesst es weg. Gemessen wird die
         lange Fassung: braucht sie mehr als eine Zeile, wird auf die kurze
         umgeschaltet. So entscheidet die tatsaechliche Breite des Geraets,
         nicht eine geratene Zeichenzahl. */
      fitTexts() {
        this.items.forEach((item) => {
          const full = item.querySelector('[data-full]');
          const brief = item.querySelector('[data-brief]');
          if (!full || !brief) return;

          full.hidden = false;
          brief.hidden = true;

          const styles = window.getComputedStyle(full);
          const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.4 || 18;

          if (full.offsetHeight > lineHeight * 1.6) {
            full.hidden = true;
            brief.hidden = false;
          }
        });
      }

      handleResize() {
        const width = this.offsetWidth;
        if (width !== this.lastWidth) {
          this.lastWidth = width;
          this.fitTexts();
        }
        this.setHeight();
      }

      buildDots() {
        this.dotsContainer = this.querySelector('.rot-bar__dots');
        this.dots = [];
        if (!this.dotsContainer || this.items.length < 2) {
          this.dotsContainer?.remove();
          return;
        }
        this.items.forEach((item, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'rot-bar__dot';
          dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
          dot.setAttribute('aria-label', String(i + 1));
          dot.addEventListener('click', () => {
            this.stop();
            this.show(i);
            this.start();
          });
          this.dotsContainer.appendChild(dot);
          this.dots.push(dot);
        });
      }

      setHeight() {
        const height = this.items.reduce((max, item) => Math.max(max, item.offsetHeight), 0);
        if (height > 0) this.viewport.style.height = height + 'px';
      }

      show(next) {
        const total = this.items.length;
        const target = ((next % total) + total) % total;
        if (target === this.index) return;

        const current = this.items[this.index];
        const upcoming = this.items[target];

        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        current.setAttribute('aria-hidden', 'true');
        window.setTimeout(() => current.classList.remove('is-leaving'), 800);

        upcoming.classList.remove('is-leaving');
        upcoming.classList.add('is-active');
        upcoming.removeAttribute('aria-hidden');

        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === target ? 'true' : 'false'));
        this.index = target;
      }

      start() {
        if (!this.autoRotate || this.timer) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  );
}

document.addEventListener('shopify:block:select', (event) => {
  const bar = event.target.closest('rotating-announcement-bar');
  if (!bar || typeof bar.show !== 'function') return;
  bar.stop();
  bar.show(bar.items.indexOf(event.target));
});

document.addEventListener('shopify:block:deselect', (event) => {
  const bar = event.target.closest('rotating-announcement-bar');
  if (bar && typeof bar.start === 'function') bar.start();
});
